'use strict';

function date() {
    const date = document.querySelector('#date');

    let now = new Date();

    let year = now.getFullYear(),
        month = now.getMonth(),
        day = now.getDate(),
        dayOfWeek = now.getDay();

    setInterval(showDate, 1000);

    function showDate() {

        if (dayOfWeek == '0') {
            dayOfWeek = 'Воскресенье';
        }

        if (dayOfWeek == '1') {
            dayOfWeek = 'Понедельник';
        }

        if (dayOfWeek == '2') {
            dayOfWeek = 'Вторник';
        }

        if (dayOfWeek == '3') {
            dayOfWeek = 'Среда';
        }

        if (dayOfWeek == '4') {
            dayOfWeek = 'Четверг';
        }

        if (dayOfWeek == '5') {
            dayOfWeek = 'Пятница';
        }

        if (dayOfWeek == '6') {
            dayOfWeek = 'Суббота';
        }

        if (month == '0') {
            month = 'января';
        }

        if (month == '1') {
            month = 'февраля';
        }

        if (month == '2') {
            month = 'марта';
        }

        if (month == '3') {
            month = 'апреля';
        }

        if (month == '4') {
            month = 'мая';
        }

        if (month == '5') {
            month = 'июня';
        }

        if (month == '6') {
            month = 'июля';
        }

        if (month == '7') {
            month = 'августа';
        }

        if (month == '8') {
            month = 'сентября';
        }

        if (month == '9') {
            month = 'октября';
        }

        if (month == '10') {
            month = 'ноября';
        }

        if (month == '11') {
            month = 'декабря';
        }

        try {
            date.textContent = `${dayOfWeek}, ${day} ${month} ${year} года`;
        } catch(e) {}
    }
}

export default date;